<template>
  <div>
    <Modal title="Register to attend mass">
      <div slot="body">
        <div class="row mt-4">
          <div class="form-group col-md-6 col-sm">
            <label for="first-name">First name</label>
            <input type="text" id="first-name" placeholder="" class="form-control"
              v-model="userDetails.firstName">
          </div>

          <div class="form-group col-md-6 col-sm">
            <label for="last-name">Last name</label>
            <input type="text" id="last-name" placeholder="" class="form-control"
              v-model="userDetails.lastName">
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6 col-sm">
            <label for="email-address">Email Address</label>
            <input type="text" id="email-address" placeholder="e.g example@mail.com"
              class="form-control" v-model="userDetails.email">
          </div>

          <div class="form-group col-md-6 col-sm">
            <label for="phone-number">Phone Number</label>
            <input type="text" id="phone-number" placeholder="" class="form-control"
              v-model="userDetails.phoneNumber">
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6 col-sm">
            <label for="gender">Gender</label>
            <select name="gender" id="gender" class="form-control" v-model="userDetails.gender">
              <option value="">Select</option>
              <option value="1">Male</option>
              <option value="2">Female</option>
            </select>
          </div>

          <div class="form-group col-md-6 col-sm">
            <label for="mass-time">Mass time</label>
            <select id="mass-time" class="form-control" v-model="userDetails.massTime">
              <option value="">Select</option>
              <option value="1">7:00am</option>
              <option value="2">9:00am</option>
              <option value="3">11:00am</option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-12 col-sm">
            <label for="address">Address</label>
            <input type="text" id="address" class="form-control" v-model="userDetails.address">

          </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="toggleModal">Close</button>
          <button type="button" class="btn btn-primary" @click="registerMass">Register</button>
        </div>



      </div>

    </Modal>

  </div>
</template>

<script>
import axios from 'axios';
import Modal from '@/components/modal/Modal.vue';
export default {
  data() {
    return {
      userDetails: {
        firstName: '',
        lastName: '',
        massTime: '',
        email: '',
        address: '',
        gender: '',
        phoneNumber: ''
      }
    }
  },
  components: {
    Modal
  },
  methods: {
    async registerMass() {
       try {
        const response = await axios.post(`/mass/registerForMass`, JSON.stringify(this.userDetails));
        const data = await response;
        console.log(data);
      } catch (error) {
        console.error("error", error);
      }
    },
    toggleModal() {
      this.$emit('close')
      this.userDetails.firstName = ''
      this.userDetails.lastName = ''
      this.userDetails.massTime = ''
      this.userDetails.email = ''
      this.userDetails.gender = ''
      this.userDetails.phoneNumber = ''
      this.userDetails.address = ''
    }
  }

}
</script>


<style scoped>
.form-group input:focus, textarea:focus{
     outline:0px !important;
     box-shadow: none !important;
  }
</style>
